export enum AdminTab {
  Users = 'users',
  Clinics = 'clinics',
  LifeglovLinerStock = 'lifeglov-liner-stock'
}
